module.exports = __webpack_public_path__ + "img/lapaire.33b458a7.jpg";